module.exports = __webpack_public_path__ + "static/media/send-message-icon.54a39182.png";